import React, { useState } from "react"
import { useStaticQuery, graphql, Link as L } from "gatsby"
import Img from "gatsby-image"
import { Link, animateScroll } from "react-scroll"
import useScrollPosition from "@react-hook/window-scroll"

// Component
import ShoppingCart from "../ShoppingCart/ShoppingCart"
import NavModal from "./NavModal/NavModal"

// Styles
import "./Navigation.scss"

import BurgerMenu from "../../images/menu.svg"

const Navigation = ({ site }) => {
  const scrollY = useScrollPosition(60)
  const [modalState, setModalState] = useState(false)

  const navImg = useStaticQuery(graphql`
    query {
      facebookLogo: file(relativePath: { eq: "facebook_logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const navModalHandeler = () => {
    setModalState(!modalState)
  }

  return (
    <>
      <div
        className={`navigation-container ${
          scrollY > 200 ? "fadeIn" : "fadeOut"
        }`}
        id="scroll-navigation"
      >
        <nav>
          <ul className="navigation-list">
            <li onClick={navModalHandeler}>
              <img src={BurgerMenu} alt="Menu" />
            </li>
            <li>
              {site === "intex" ? (
                <Link
                  spy={true}
                  smooth={true}
                  duration={500}
                  activeClass="active"
                  to="home"
                  className="nav-home"
                >
                  Home
                </Link>
              ) : (
                <L to="/#home" className="nav-home">
                  Home
                </L>
              )}
            </li>
            <li>
              {site === "index" ? (
                <Link
                  spy={true}
                  smooth={true}
                  duration={500}
                  activeClass="active"
                  to="veranstaltungen"
                  className="nav-varenstaltungen"
                >
                  Veranstaltungen
                </Link>
              ) : (
                <L to="/#veranstaltungen" className="nav-varenstaltungen">
                  Veranstaltungen
                </L>
              )}
            </li>
            <li>
              {site === "index" ? (
                <Link
                  spy={true}
                  smooth={true}
                  duration={500}
                  activeClass="active"
                  to="fahrgeschaefte"
                  className="nav-booking"
                >
                  Fahrgeschäfte
                </Link>
              ) : (
                <L to="/#fahrgeschaefte" className="nav-booking">
                  Fahrgeschäfte
                </L>
              )}
            </li>
            <li>
              {site === "index" ? (
                <Link
                  spy={true}
                  smooth={true}
                  duration={500}
                  activeClass="active"
                  to="eiswagen"
                  className="nav-eissorten"
                >
                  Eiswagen
                </Link>
              ) : (
                <L to="/#eiswagen" className="nav-eissorten">
                  Eiswagen
                </L>
              )}
            </li>
            <li>
              <Link
                spy={true}
                smooth={true}
                duration={500}
                activeClass="active"
                to="footer"
                className="nav-kontakt"
              >
                Kontakt
              </Link>
            </li>
            <li>
              <a href="https://www.facebook.com/Eis-Charlie-159432034168973/">
                <Img fluid={navImg.facebookLogo.childImageSharp.fluid} />
              </a>
            </li>
            {site === "datenschutz" ? null : (
              <li>
                <ShoppingCart />
              </li>
            )}
          </ul>
        </nav>
      </div>
      <NavModal
        site={site}
        modalState={modalState}
        handeler={navModalHandeler}
      />
    </>
  )
}

export default Navigation
